/**
 * Produces a script-safe JSON expression for Vite SSG's inline state payload.
 */
export function transformSsgState(state: unknown): unknown {
  if (!import.meta.env.SSR) return state

  return JSON.stringify(state)
    .replace(/</g, '\\u003C')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}
